<template>
  <div class="box-input-data">
    <Navbar />
    <div class="input-data">
      <b-form @submit="addEbid">
        <b-container class="box">
          <b-row class="justify-content-center">
            <b-col lg="7" class="text-left title-text">
              <h4>
                <b>ประกาศผู้ชนะการเสนอราคา</b>
              </h4>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col lg="7" class="text-left content-text">
              <b-row class="mt-2">
                <b-col lg="6" md="6">
                  <b-row>
                    <b-col lg="4" md="4">
                      บริษัท
                      <span class="required">*</span>
                    </b-col>
                    <b-col>
                      <div class="input-group mb-3">
                        <b-form-input
                          disabled
                          required
                          v-model="form.company_name"
                          size="sm"
                        ></b-form-input>
                        <div class="input-group-append">
                          <span
                            class="input-group-text"
                            style="
                              padding: 0px;
                              border: 0px;
                              background-color: #fff;
                            "
                          >
                            <b-button
                              id="myBtnCompany"
                              @click="searchCompany"
                              style="margin-left: 3px"
                              size="sm"
                              class="btnAdd"
                            >
                              <font-awesome-icon icon="search" />
                            </b-button>
                            <b-button
                              @click="addCompany"
                              style="margin-left: 3px"
                              size="sm"
                              class="btnAdd"
                            >
                              <font-awesome-icon icon="plus" />
                            </b-button>
                          </span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="6" md="6">
                  <b-row>
                    <b-col lg="5" md="5">
                      วันที่ประกาศ
                      <span class="required">*</span>
                    </b-col>
                    <b-col>
                      <b-form-input
                        ref="date-input"
                        size="sm"
                        v-model="form.announce_date"
                        @input="setDate"
                        required
                      ></b-form-input>
                      <small>วว/ดด/ปปปป (01/02/2563)</small>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col lg="12">
                  <b-row>
                    <b-col lg="2" md="2">
                      โครงการ
                      <span class="required">*</span>
                    </b-col>
                    <b-col>
                      <div class="input-group mb-3">
                        <b-form-textarea
                          size="sm"
                          v-model="form.project_name"
                          @input="form.project_name = form.project_name.trim()"
                          required
                          rows="5"
                        ></b-form-textarea>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col lg="6" md="6">
                  <b-row>
                    <b-col lg="4" md="4">
                      จังหวัด
                      <span class="required">*</span>
                    </b-col>
                    <b-col>
                      <div class="input-group mb-3">
                        <b-form-input
                          disabled
                          required
                          size="sm"
                          v-model="form.province_name"
                        ></b-form-input>
                        <div class="input-group-append">
                          <span
                            class="input-group-text"
                            style="
                              padding: 0px;
                              border: 0px;
                              background-color: #fff;
                            "
                          >
                            <b-button
                              id="myBtnProvince"
                              @click="searchProvince"
                              style="margin-left: 3px"
                              size="sm"
                              class="btnAdd"
                            >
                              <font-awesome-icon icon="search" />
                            </b-button>
                          </span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="6" md="6">
                  <b-row>
                    <b-col lg="5" md="5">
                      รหัสโครงการ
                      <span class="required">*</span>
                    </b-col>
                    <b-col>
                      <b-form-input
                        size="sm"
                        type="number"
                        @input="form.project_no = form.project_no.trim()"
                        v-model="form.project_no"
                        required
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col lg="12">
                  <b-row>
                    <b-col lg="2" md="2">
                      หน่วยงาน
                      <span class="required">*</span>
                    </b-col>
                    <b-col>
                      <div class="input-group mb-3">
                        <b-form-input
                          size="sm"
                          v-model="form.employor"
                          @input="form.employor = form.employor.trim()"
                          required
                        ></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col lg="6" md="6">
                  <b-row>
                    <b-col lg="4" md="4">
                      ราคากลาง
                      <span class="required">*</span>
                    </b-col>
                    <b-col>
                      <b-form-input
                        size="sm"
                        @input="
                          form.standard_price = form.standard_price.trim()
                        "
                        v-model="form.standard_price"
                        required
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="6" md="6">
                  <b-row>
                    <b-col lg="5" md="5">
                      ราคาประมูล
                      <span class="required">*</span>
                    </b-col>
                    <b-col>
                      <b-form-input
                        size="sm"
                        @input="setDigitThai"
                        v-model="form.auction_price"
                        required
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col lg="6" md="6">
                  <b-row>
                    <!-- <b-col lg="4" md="4">วันเชิญชวน</b-col> -->
                    <b-col lg="4" md="4">ประกาศ</b-col>
                    <b-col>
                      <div class="input-group mb-3">
                        <b-form-file
                          size="sm"
                          @input="getBase64()"
                          placeholder="คลิกเพื่อเลือก"
                          v-model="file_pdf"
                          browse-text="ไฟล์"
                          accept=".pdf"
                        ></b-form-file>
                        <!-- <b-form-datepicker size="sm" locale="th" v-model="form.date_invite"></b-form-datepicker>
                        <div class="input-group-append">
                          <span
                            class="input-group-text"
                            style="padding:0px; border:0px; background-color: #fff;"
                          >
                            <b-button
                              id="myBtnProvince"
                              @click="form.date_invite = null"
                              style="margin-left:3px;"
                              size="sm"
                              class="btnAdd"
                            >
                              <font-awesome-icon icon="redo-alt" />
                            </b-button>
                          </span>
                        </div> -->
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="6" md="6">
                  <b-row>
                    <b-col lg="5" md="5">ประเภทงาน</b-col>
                    <b-col>
                      <b-form-select
                        size="sm"
                        v-model="form.job_type"
                        :options="options_job_type"
                      ></b-form-select>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col lg="12" class="text-center">
                  <b-button size="sm" class="mt-4 mb-3 btnAdd" type="submit">
                    <font-awesome-icon icon="save" />&nbsp;บันทึก
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </div>
    <b-modal
      ref="modal-scrollable-company"
      scrollable
      title="บริษัท/ห้าง"
      hide-footer
      hide-header-close
    >
      <vue-good-table
        :search-options="{ enabled: true }"
        :columns="columns_company"
        :rows="rows_company"
        @on-row-click="selectCompany"
        :pagination-options="{
          enabled: true,
          perPage: 7,
          position: 'bottom',
          setCurrentPage: 1,
          nextLabel: 'ถัดไป',
          prevLabel: 'ก่อนหน้า',
          rowsPerPageLabel: 'จำนวนข้อมูลต่อหน้า',
          ofLabel: 'จาก',
          pageLabel: 'หน้า',
        }"
      />
    </b-modal>
    <b-modal
      ref="modal-scrollable-province"
      scrollable
      title="จังหวัด"
      hide-footer
      hide-header-close
      size="sm"
    >
      <vue-good-table
        :search-options="{ enabled: true }"
        :columns="columns_province"
        :rows="rows_province"
        @on-row-click="selectProvince"
      />
    </b-modal>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
export default {
  components: { Navbar, Footer, VueGoodTable },
  mounted() {
    document.getElementById("myBtnCompany").disabled = true;
    document.getElementById("myBtnProvince").disabled = true;
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/jobtype")
      .then((res) => {
        this.options_job_type = res.data.response;
      });
    axios.get("http://www.geoplugin.net/json.gp").then((res) => {
      this.ipaddress = res.data.geoplugin_request;
    });
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/province_name")
      .then((res) => {
        if (res.data.statusProvince) {
          this.rows_province = res.data.response;
          document.getElementById("myBtnProvince").disabled = false;
        }
      });
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/company_name")
      .then((res) => {
        if (res.data.statusCompany) {
          this.rows_company = res.data.response;
          document.getElementById("myBtnCompany").disabled = false;
        }
      });
  },
  data() {
    return {
      ipaddress: null,
      options_job_type: [],
      form: {
        date_invite: null,
        job_type: null,
        project_name: null,
        announce_date: null,
        province_name: null,
        project_no: null,
        company_name: null,
        standard_price: null,
        auction_price: null,
        employor: null,
        creator: null,
        file_pdf: null,
      },
      file_pdf: [],
      columns_company: [
        {
          label: "คำนำหน้า",
          field: "ebidding_company_type",
        },
        {
          label: "ชื่อ",
          field: "ebidding_customer_name",
        },
      ],
      rows_company: [],
      columns_province: [
        {
          label: "จังหวัด",
          field: "name_th",
        },
      ],
      rows_province: [],
    };
  },
  methods: {
    addEbid: function (e) {
      e.preventDefault();
      this.form.standard_price = this.form.standard_price.replace(/,/g, "");
      this.form.creator = this.$session.get("username");
      let pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
      if (this.form.province_name === null || this.form.company_name === null) {
        this.$bvToast.toast(
          "ไม่สามารถบันทึกข้อมูลได้ กรุณากรอกข้อมูลให้ครบทุกช่อง",
          {
            title: "ผิดพลาด",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "danger",
          }
        );
      } else if (!pattern.test(this.form.announce_date)) {
        this.$bvToast.toast("กรุณากรอกวันที่ให้ถูกต้อง (วว/ดด/ปปปป)", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
        });
        this.$refs["date-input"].focus();
      } else {
        let text = "";
        if (
          parseFloat(
            (
              ((parseFloat(this.form.standard_price) -
                parseFloat(this.form.auction_price)) /
                parseFloat(this.form.standard_price)) *
              100
            ).toFixed(2)
          ) > 50
        ) {
          text = "ส่วนลดของการประมูลมีค่ามากกว่า 50 % ";
        } else {
          text = "";
        }
        this.$bvModal
          .msgBoxConfirm(text + "ต้องการบันทึกข้อมูลโครงการใช่หรือไม่", {
            title: "ต้องการดำเนินการต่อไหม?",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            cancelVariant: "danger",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "ตกลง",
            cancelTitle: "ยกเลิก",
          })
          .then((value) => {
            if (value) {
              axios
                .post(
                  "https://www.kmppartners.info:1009/api/ebidding/addEbid",
                  this.form
                )
                .then((res) => {
                  if (res.data.statusAdd) {
                    this.$bvModal
                      .msgBoxOk("บันทึกข้อมูลเรียบร้อยเเล้ว", {
                        title: "สำเร็จ",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        headerClass: "p-2 border-bottom-0",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                        okTitle: "ตกลง",
                      })
                      .then((value) => {
                        if (value) {
                          axios.post(
                            "https://www.kmppartners.info:1009/api/notify/crm",
                            {
                              customer_name: this.form.company_name,
                              project_no: this.form.project_no,
                              province: this.form.province_name,
                              value: this.form.auction_price,
                            }
                          );
                          axios
                            .post(
                              "https://www.kmppartners.info:1009/api/ebidding/access_log",
                              {
                                access_username: this.$session.get("username"),
                                access_module: "เพิ่มประกาศ E-Bidding",
                                access_ipaddress: this.ipaddress,
                              }
                            )
                            .then((rest) => {
                              if (rest.data.statusLog) {
                                this.$router.push("/Overview");
                              }
                            });
                        }
                      });
                  } else {
                    this.$bvModal
                      .msgBoxOk(res.data.error, {
                        title: "ผิดพลาด",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "danger",
                        headerClass: "p-2 border-bottom-0",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                        okTitle: "ตกลง",
                      })
                      .then((value) => {
                        if (value) {
                          location.reload();
                        }
                      });
                  }
                });
            }
          });
      }
    },
    getBase64: function () {
      if (this.file_pdf.type === "application/pdf") {
        let reader = new FileReader();
        reader.readAsDataURL(this.file_pdf);
        reader.onload = () => {
          this.form.file_pdf = reader.result;
        };
      } else {
        this.file_pdf = null;
        this.form.file_pdf = null;
        alert("รองรับเฉพาะ PDF เท่านั้น");
      }
    },
    addCompany: function () {
      this.$router.push("/Inputcompany");
    },
    selectCompany: function (params) {
      this.form.company_name = params.row.ebidding_customer_name;
      this.$refs["modal-scrollable-company"].hide();
    },
    searchCompany: function () {
      this.$refs["modal-scrollable-company"].show();
    },
    selectProvince: function (params) {
      this.form.province_name = params.row.name_th;
      this.$refs["modal-scrollable-province"].hide();
    },
    searchProvince: function () {
      this.$refs["modal-scrollable-province"].show();
    },
    setDate: function () {
      this.form.announce_date = this.form.announce_date.trim();
    },
    setDigitThai: function () {
      this.form.auction_price = this.form.auction_price.trim();
      this.form.auction_price = parseFloat(
        this.form.auction_price
          .replace(/๑/g, "1")
          .replace(/๒/g, "2")
          .replace(/๓/g, "3")
          .replace(/๔/g, "4")
          .replace(/๕/g, "5")
          .replace(/๖/g, "6")
          .replace(/๗/g, "7")
          .replace(/๘/g, "8")
          .replace(/๙/g, "9")
          .replace(/๐/g, "0")
          .replace(/,/g, "")
      );
    },
  },
};
</script>

<style>
.box-input-data {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.input-data {
  font-family: "K2D";
  margin: 5% !important;
  padding-bottom: 10%;
}
@media (max-width: 600px) {
  .input-data {
    padding-bottom: 80% !important;
  }
}
@media (max-width: 1024px) {
  .input-data {
    margin-bottom: 20% !important;
  }
}
.box {
  margin: auto !important;
}
.title-text {
  color: white;
  background-color: #005a7c;
  padding: 1%;
}
.content-text {
  color: black;
  background-color: white;
  padding: 1%;
}
.btnAdd {
  background-color: #005a7c !important;
}
.btnAdd:hover {
  background-color: rgb(27, 27, 27) !important;
}
.required {
  color: red;
}
</style>
